import React from 'react';
import { Box, Typography, Autocomplete, TextField } from '@mui/material';
import { colors, fonts } from '../../../../constants';
import { QUERY_TYPE_OPTIONS } from '../../../../constants/raiseQueryForm';
import FormFieldLabel from '../FormFieldLabel';
import { getSelectStyle, getHelperTextStyles } from '../../../../utils/formUtils';

/**
 * QueryTypeField Component
 * Query type selection field
 */
const QueryTypeField = ({
  formData,
  errors,
  focusedFields,
  queryTypeOptions = QUERY_TYPE_OPTIONS,
  handleChange,
  handleFocus,
  handleBlur,
}) => {
  const helperTextBaseStyles = getHelperTextStyles();

  const getSelectStyleWithFocus = (field, hasError) => {
    const isFocused = focusedFields[field];
    return getSelectStyle(field, hasError, isFocused);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <FormFieldLabel label="Query Type" />
      <Autocomplete
        options={queryTypeOptions}
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        value={formData.queryType ? queryTypeOptions.find((opt) => opt.value === formData.queryType) || null : null}
        onChange={(event, newValue) => {
          const value = newValue ? newValue.value : '';
          handleChange('queryType')({ target: { value } });
        }}
        onFocus={handleFocus('queryType')}
        onBlur={handleBlur('queryType')}
        openOnFocus
        filterOptions={(options, params) => {
          const filtered = options.filter((option) =>
            option.label.toLowerCase().includes(params.inputValue.toLowerCase())
          );
          return filtered;
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              readOnly: false,
              autoComplete: 'off',
            }}
            placeholder="Select a query type"
            error={!!errors.queryType}
            sx={{
              '& .MuiOutlinedInput-root': {
                ...getSelectStyleWithFocus('queryType', !!errors.queryType),
                padding: '4px 9px',
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
              '& .MuiInputBase-input': {
                padding: '8px 4px',
                fontSize: fonts.fontSizeMd,
                cursor: 'text',
              },
            }}
          />
        )}
        sx={{
          width: '100%',
          '& .MuiAutocomplete-inputRoot': {
            padding: '0 !important',
          },
          '& .MuiSvgIcon-root': {
          color: colors.primaryDark,
          },
          '& .MuiAutocomplete-tag': {
          backgroundColor: colors.primaryTint,
          color: colors.primaryDark,
          },
          '& .MuiAutocomplete-option': {
            '&.Mui-focused': {
            backgroundColor: colors.primaryTint,
            },
            '&[aria-selected="true"]': {
            backgroundColor: colors.primaryTintHover,
              '&.Mui-focused': {
              backgroundColor: colors.primaryTintHover,
              },
            },
          },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          ...helperTextBaseStyles,
        color: errors.queryType ? colors.error : colors.primaryDark,
        }}
      >
        {errors.queryType}
      </Typography>
    </Box>
  );
};

export default QueryTypeField;
